import {
    FAILED_TO_GET_SOLICITOR_HOME_PAGE_INFO, GET_SOLICITOR_HOME_PAGE_INFO,
    RECEIVE_SOLICITOR_HOME_PAGE_INFO
} from "./index";

//action that requests the solicitor home page info
export function getSolicitorHomePageInfo() {
    return {
        type: GET_SOLICITOR_HOME_PAGE_INFO
    }
}

//action that receives the solicitor home page info
export function receiveSolicitorHomePageInfo(info) {
    return {
        type: RECEIVE_SOLICITOR_HOME_PAGE_INFO,
        payload: info
    }
}

//action that receives failed response from getting the solicitor home page info
export function failedToGetSolicitorHomePageInfo(response) {
    return {
        type: FAILED_TO_GET_SOLICITOR_HOME_PAGE_INFO,

    }
}